import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const MountBreadCrumbContext = createContext({});

export const MountBreadCrubProvider = ({ children }) => {
    const [breadCrumb, setBreadCrumb] = useState(null);

    return (
        <MountBreadCrumbContext.Provider
            value={{
                breadCrumb,
                setBreadCrumb
            }}
        >
            {children}
        </MountBreadCrumbContext.Provider>
    );
};

MountBreadCrubProvider.propTypes = {
    children: PropTypes.any
};

/**
 *
 * @returns {{setBreadCrumb: React.Dispatch<React.SetStateAction<JSX.Element>>}}
 */
export const useMountBreadCrumb = () => {
    const context = useContext(MountBreadCrumbContext);
    return context;
};
